import { Theme, css } from '@emotion/react';
import React, { Children } from 'react';

import { fontStyles } from '~src/theme/fontStyles';

export const Separator: React.FC<React.HTMLAttributes<HTMLElement>> = ({ children, ...props }) => {
  /**
   * When inserted as a pseudo element, the dot is being read by screen readers
   */
  const ariaSeparator = (
    <span css={styles.separator} aria-hidden="true">
      ·
    </span>
  );

  const enhancedChildren = Children.toArray(children).flatMap((val, i, arr) =>
    i < arr.length - 1 ? [val, React.cloneElement(ariaSeparator, { key: `s-${i}` })] : val
  );

  return (
    <div css={styles.wrapper} {...props}>
      {enhancedChildren}
    </div>
  );
};

const styles = {
  wrapper: (theme: Theme) =>
    css({
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      color: theme.neutral35,
      ...fontStyles.px12_16,
    }),
  separator: (theme: Theme) => ({
    margin: '0 6px',
    color: theme.neutral35,
  }),
};
